import { openServiceRoute } from './serviceNavigation'

export const DEFAULT_SHORTCUT_CODES = ['activities', 'trainingAndLearning']

export function normalizeServiceMenus(list) {
  return list.filter(item => item && typeof item.menuCode === 'string' && item.menuCode)
    .slice().sort((a, b) => (a.menuSort || 0) - (b.menuSort || 0))
    .map(item => {
      const childrenList = Array.isArray(item.childrenList) ? normalizeServiceMenus(item.childrenList) : []
      return {
        ...item, menuName: item.menuName || item.menuCode, childrenList,
        menuUrl: childrenList.length ? item.menuCode : '/service/' + item.menuCode
      }
    })
}

export function flattenServiceMenus(menus) {
  const result = []
  menus.forEach(root => {
    result.push({ ...root, parentCode: '', parentName: '', menuPath: root.menuName })
    root.childrenList.forEach(child => {
      result.push({ ...child, parentCode: root.menuCode, parentName: root.menuName, menuPath: root.menuName + ' / ' + child.menuName })
    })
  })
  return result
}

export function shortcutCandidates(menus, router) {
  const canOpen = menu => {
    if (menu.menuCode === 'exit' || menu.childrenList.length) return false
    const { route } = router.resolve(menu.menuUrl)
    return route.matched.some(record => record.meta.section === 'service')
  }
  return menus.filter(root => root.menuCode !== 'exit').map(root => {
    const childrenList = root.childrenList.filter(canOpen).map(child => ({
      ...child, parentCode: root.menuCode, parentName: root.menuName,
      menuPath: root.menuName + ' / ' + child.menuName
    }))
    if (root.childrenList.length && !childrenList.length) return null
    return { ...root, parentCode: '', parentName: '', menuPath: root.menuName, childrenList }
  }).filter(root => root && (root.childrenList.length || canOpen(root)))
}

export function activeServiceMenu(menus, route) {
  const all = flattenServiceMenus(menus)
  return all.find(menu => menu.menuUrl === route.path) ||
    all.find(menu => menu.menuCode === route.meta.serviceMenuCode) || null
}

export function shortcutName(menu) {
  // 快捷入口与左侧菜单、配置树统一使用租户返回的菜单名称。
  return menu.menuName
}

export function activateServiceMenu(router, menu) {
  return !!menu && !menu.childrenList.length && menu.menuCode !== 'exit' && openServiceRoute(router, menu.menuUrl)
}
